













































import { Vue, Component } from "@/shared/vuepack";
import * as ucb from "@/shared/ucbUrls";
import { openUrl } from "@/shared/urlHelper";

@Component({
  components: {
  }
})
export default class UcbForms extends Vue {
  UcbUrls = ucb;

  clickLink (event) {
    openUrl(event.currentTarget.href);
  }
}
